export default __webpack_public_path__ + "static/media/venda-liquida.347ae568.png";